import { Link, useNavigate } from "react-router-dom";
import Tooltip from "../Tooltip/tooltip";
import { FiHome } from "react-icons/fi";
import { IoStorefrontOutline } from "react-icons/io5";
import { PiChatTeardropText } from "react-icons/pi";
import { MdArrowDropDown } from "react-icons/md";
import { useDispatch } from "react-redux";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { EcobookProfile } from "../../types";
import React from "react";
import { PROFILE_DETAILS } from "../../apollo/operations";
import { useQuery } from "@apollo/client";
import { setUserDetails } from "../../redux/slices/userSlice";
import SkeletonElement from "../skeletons/skeletonElement";
import { Shimmer } from "..";
import { CiUser } from "react-icons/ci";

const NAVBar: React.FC = () => {
  // const user = useSelector((state: any) => state.user.userDetails);
  const userID = window.localStorage.getItem("user");
  const [profileDetails, setProfileDetails] = React.useState<
    EcobookProfile | undefined
  >(undefined);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // if ((userID && user.id) === null) {
  //   showToast("Please login", "warn");
  //   navigate("/auth");
  // }
  const { loading, error } = useQuery(PROFILE_DETAILS, {
    variables: {
      where: {
        id: userID,
      },
    },
    onCompleted: (data) => {
      // console.log(data.user);
      dispatch(setUserDetails(data.user));
      setProfileDetails(data.user);
    },
    onError: (error) => {
      console.log(error);
      // showToast(error.message, "error");
      navigate("/auth");
    },
  });

  const add = "+ad4e_nj";
  if (error || userID === null) {
    console.log("Navigating to /auth");
    navigate("/auth");
  }
  // else {
  //   idRef = `${user.id}${add}`;
  // }
  const [goto, setGoto] = React.useState(false);

  let _profileImage: string | null | undefined =
    profileDetails?.ecobookProfile?.profileImage ?? "";

  // console.log(_profileImage, "_profileImage");
  // const messagesRef2 = collection(db, "ecobookChat", `${userID}`, "chats");
  // const getChat = query(messagesRef2, where("unreadMessages", ">", 0));
  // const [otherDetails, isLoading, feedError] = useCollection(getChat);

  // const getNotifications =
  //   otherDetails && otherDetails?.docs.map((doc) => ({ ...doc.data() }));
  // console.log(getNotifications, "getNotifications");

  return (
    <div className="w-[100%] fixed top-0 h-[63px] z-20 bg-white flex lg:justify-between lg:pl-[99px] lg:pr-24 shadow-md">
      <div className="flex justify-between items-center px-4 py-4 w-full lg:hidden">
        {/* <div className="flex mr-3">
          <RxHamburgerMenu size={24} className="text-[#2E3A59]"/>
        </div> */}
        {/* <li className="relative flex justify-center items-center w-[80%]">
          <input
            type="text"
            className="bg-searchCol bg-opacity-5 text-searchCol pl-[79px] pr-3 w-full h-9 rounded-full outline-none"
          />
          <div className="absolute w-4 left-1 top-1">
            <LuSearch size={29} className="text-[#33363F]" />
          </div>
        </li> */}
        <div className="flex gap-1 items-center relative">
          <li className="w-10 flex flex-1 hover:bg-comPagBg hover:rounded hover:shadow items-center justify-center">
            <Tooltip tooltip="Profile">
              <Link to={`/ecobook/profile/${userID}${add}`}>
                <div className="w-6 h-6">
                  {_profileImage ? (
                    <img
                      alt=""
                      src={ipfsGatewayImage(_profileImage!)}
                      className="rounded-full"
                    />
                  ) : (
                    <div className="w-6 h-6 bg-slate-100 flex items-center justify-center rounded-full">
                      <CiUser size={18} />
                    </div>
                  )}
                </div>
              </Link>
            </Tooltip>
          </li>
          <MdArrowDropDown size={25} onClick={() => setGoto(!goto)} />
          {goto && (
            <Link
              to={`/vehicles`}
              className="absolute left-3 top-5 bg-midGreen text-center rounded-sm rounded-tr-none shadow-[1px_-1px_10px_5px_rgba(0,0,0,0.1)] transform translate-y-1 ease-linear font-Poppins text-xs p-2 font-semibold text-white "
            >
              Switch to Ecomoto
            </Link>
          )}
        </div>
      </div>
      <ul className="hidden lg:flex p-3">
        <li className="flex-1">
          <h1 className="comHead mr-28">ECOBOOK</h1>
        </li>
        {/* <li className="relative ">
          <input
            type="text"
            placeholder="Search"
            className=" bg-searchCol bg-opacity-5 text-searchCol pl-[79px] pr-3  w-52 h-7 rounded-md outline-none"
          />
          <div className="absolute w-4 left-14 top-2">
            <CiSearch className=" text-exploreCol" />
          </div>
        </li> */}
      </ul>
      <ul className="hidden lg:flex p-3 gap-6">
        <li className="w-10 flex-1 flex hover:bg-comPagBg hover:rounded hover:shadow items-center justify-center">
          <Tooltip tooltip="Home">
            <Link to="/ecobook">
              <FiHome size={21} className="text-[#222222]" />
            </Link>
          </Tooltip>
        </li>
        <li className="w-10 flex flex-1 hover:bg-comPagBg hover:rounded hover:shadow items-center justify-center">
          <Tooltip tooltip="Discover">
            <Link to="/ecobook/my-communities">
              <IoStorefrontOutline size={21} className="text-[#222222]" />
            </Link>
          </Tooltip>
        </li>
        <li className="w-10 flex flex-1 hover:bg-comPagBg hover:rounded hover:shadow items-center justify-center relative">
          <Tooltip tooltip="Chat">
            <Link to="/chat/e">
              <PiChatTeardropText size={25} />
            </Link>
          </Tooltip>
          {/* {!feedError &&
            getNotifications &&
            getNotifications.map((notification) => (
              <b className="bg-midGreen text-[#fff] min-w-[16px] h-4 rounded-full flex justify-center font-Poppins items-center text-[8px] top-[2px] right-[2px] absolute">
                {isLoading && <p>.</p>}
                {notification.unreadMessages / 2}
              </b>
            ))} */}
        </li>
        {/* <li className="w-10 flex flex-1 hover:bg-comPagBg hover:rounded hover:shadow items-center justify-center">
          <Tooltip tooltip="">
            <Link to="Create">
              <BsPlusSquare  size={18}/>
            </Link>
          </Tooltip>
        </li> */}
        {/* <li className="w-10 flex flex-1 hover:bg-comPagBg hover:rounded hover:shadow items-center justify-center">
          <Tooltip tooltip="Favorite">
            <BsHeart size={18} className="fill-[#222222]" />
          </Tooltip>
        </li> */}
        {loading ? (
          <li className="w-10 flex flex-1 hover:bg-comPagBg hover:rounded hover:shadow items-center justify-center">
            <div className="w-[22px] h-[22px] relative overflow-hidden">
              <SkeletonElement type="menu2" />
              <Shimmer />
            </div>
          </li>
        ) : (
          <li className="w-10 flex flex-1 hover:bg-comPagBg hover:rounded hover:shadow items-center justify-center">
            <Tooltip tooltip="Profile">
              <Link to={`/ecobook/profile/${userID}${add}`}>
                <div className="w-[30px] h-[30px]">
                  {_profileImage ? (
                    <img
                      alt=""
                      src={ipfsGatewayImage(_profileImage!)}
                      className="rounded-full w-[28px] h-[28px]"
                    />
                  ) : (
                    <div className="w-[28px] h-[28px] bg-slate-100 flex items-center justify-center rounded-full">
                      <CiUser size={12} />
                    </div>
                  )}
                </div>
              </Link>
            </Tooltip>
          </li>
        )}
      </ul>
    </div>
  );
};

export default NAVBar;
